/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function DocsEmbed({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M6.438 12.5H2a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v2.137" /><path stroke="currentColor" strokeWidth={1.2} d="M8.644 13.5a1 1 0 0 0 1 1H14a1 1 0 0 0 1-1V7.836a1 1 0 0 0-1-1H9.644a1 1 0 0 0-1 1z" /><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M10.838 9h1.968M10.838 11h1" /></svg>;
}
;